const rules = {
  data() {
    return {
      rules: {
        vacio: (v, field = '') => {
          if (this.externalAction === 'delete') {
            return true
          }
          return (
            !!v ||
            this.$t('error.error.required', { field: this.$tc(field) }) ||
            this.$t('error.error.empty')
          )
        },
        length0: (v) => {
          if (this.externalAction === 'delete') {
            return true
          }
          return v.length > 0 || ''
        },
        email: (value) => {
          if (!value) return true
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('error.error.invalidEmail')
        },
        nteams: (value) => {
          return range(parseInt(value)) || this.$t('error.invalidTeamRange')
        },
        min: (value) => {
          return (
            (value && value.split('').length >= 6) || this.$t('error.error.min')
          )
        },
        minNumber: (value, min = 0) => {
          return (
            (Number.isInteger(value) && value >= min) ||
            this.$t('error.error.minNumber', { field: min })
          )
        },
        maxNumber: (value, field, max = 1) => {
          return (
            (Number.isInteger(value) && value <= max) ||
            this.$t('error.error.maxNumber', {
              field: this.$tc(field),
              max: max,
            })
          )
        },
        min1: (value, field) => {
          return (
            parseInt(value) > 0 ||
            this.$t('error.error.invalidMinImage', { field: this.$tc(field) })
          )
        },
      },
    }
  },
}

export default rules

function range(value) {
  return value > 0 && value < 101
}
